module.exports = __webpack_public_path__ + "static/img/thumb_5.2cd98b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_5.png
// module id = 8zgy
// module chunks = 0